var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0233377,1.04681568 C19.6370754,0.752988241 20.4130853,1.84226414 20.3513674,4.31464337 C8.02295117,4.82657095 1.85874306,5.17029329 1.85874306,5.34581039 C1.85874306,5.60908604 2.38591169,6.1063899 2.93098686,6.1063899 L20,6.1063899 C21.6568542,6.1063899 23,7.44953565 23,9.1063899 L23,20.4937646 C23,22.0933972 21.9826535,23 20.9931379,23 L2.93098686,23 C1.97227054,23 1,22.2306417 1,20.9119481 L1,6.1063899 C1,4.30017548 1.32566527,4.03070028 2.38591169,3.65372594 C2.9160349,3.46523877 6.22023978,2.92369649 9.69448967,2.37418337 L10.8138661,2.19770408 C13.9217187,1.70907931 16.9427098,1.24357513 18.0233377,1.04681568 Z M19,13 C17.8954305,13 17,13.8954305 17,15 C17,16.1045695 17.8954305,17 19,17 C20.1045695,17 21,16.1045695 21,15 C21,13.8954305 20.1045695,13 19,13 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.66aa32ddb7e96f6d9bd4630e4160b6f7.svg";
export { ForwardRef as ReactComponent };